import { CircularTestimonials } from "@/components/ui/circular-testimonials";
import { useLanguage } from "@/contexts/LanguageContext";

const Testimonials = () => {
  const { t } = useLanguage();
  const testimonials = [
    {
      quote: t("testimonials.testimonial1.quote"),
      name: t("testimonials.testimonial1.name"),
      designation: t("testimonials.testimonial1.country"),
      src: "/images/For Testimonials/bo Dean review google.webp",
    },
    {
      quote: t("testimonials.testimonial2.quote"),
      name: t("testimonials.testimonial2.name"),
      designation: t("testimonials.testimonial2.country"),
      src: "/images/For Testimonials/Mark review img booking.webp",
    },
    {
      quote: t("testimonials.testimonial3.quote"),
      name: t("testimonials.testimonial3.name"),
      designation: t("testimonials.testimonial3.country"),
      src: "/images/For Testimonials/Agustin Moyano review google.webp",
    },
    {
      quote: t("testimonials.testimonial4.quote"),
      name: t("testimonials.testimonial4.name"),
      designation: t("testimonials.testimonial4.country"),
      src: "/images/For Testimonials/Rayleen review img booking.webp",
    },
  ];

  return (
    <section id="events" className="py-20 bg-elegant-white" data-oid="3qsehyh">
      <div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
        data-oid="m.c6g18"
      >
        <div className="text-center mb-16" data-oid="m-n6i5p">
          <h2
            className="font-playfair text-4xl md:text-5xl text-gray-900 mb-6 uppercase"
            data-oid="1:ke91r"
          >
            {t("testimonials.title")}
          </h2>
          <p className="font-lato text-lg text-gray-900" data-oid="ve4w74m">
            {t("testimonials.description")}
          </p>
        </div>

        <div className="flex justify-center" data-oid=":nnle2m">
          <CircularTestimonials
            testimonials={testimonials}
            autoplay={true}
            colors={{
              name: "#111827", // gray-900
              designation: "#A38648", // alpine-gold
              testimony: "#111827", // gray-900
              arrowBackground: "#A38648", // alpine-gold
              arrowForeground: "#FFFFFF", // elegant-white
              arrowHoverBackground: "#D62429", // swiss-red
            }}
            fontSizes={{
              name: "1.75rem",
              designation: "1rem",
              quote: "1.125rem",
            }}
            data-oid="uq9yt2a"
          />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
